<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="label-list">
          <div class="label-top">
            <div class="title">画像标签</div>
            <div class="info">
              <!-- 共38标签 -->
              <div></div>
              <div class="btn" @click="addLabelModal">+ 添加标签组</div>
            </div>
          </div>
          <div class="label">
            <el-tree
              :data="portraitList"
              :props="defaultProps"
              @node-click="handleNodeClick"
            >
              <div class="custom-tree-node" slot-scope="{ node, data }">
                <div class="name">
                  <i class="el-icon-s-order" v-if="!data.fid"></i>
                  {{ node.label }}
                </div>
                <div class="btn-box">
                  <i
                    class="el-icon-folder-add"
                    v-if="!data.fid"
                    @click.stop="addSecondLabelModal(data)"
                  ></i>
                  <i class="el-icon-delete" @click.stop="deleteLabel(data)"></i>
                </div>
              </div>
            </el-tree>
          </div>
        </div>
        <div class="label-info" v-if="labelInfo.id">
          <div class="name">{{ labelInfo.name }}</div>
          <div class="box">
            <div class="box-title">
              <div class="left">
                设置标签条件
                <div class="tip">*满足以下条件的用户获得该画像标签</div>
              </div>
              <div class="btn" @click="saveBehavior">保存条件</div>
            </div>
            <div class="behavior-list">
              <div
                class="item"
                v-for="(item, index) in upgradeRulesData"
                :key="index"
              >
                条件行为
                <el-select
                  v-model="item.behavior"
                  placeholder="请选择"
                  style="width: 220px;margin-left: 12px;margin-right: 24px;"
                >
                  <el-option
                    v-for="item in behaviorList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                操作次数
                <el-select
                  v-model="item.condition"
                  placeholder="请选择"
                  style="width: 90px;margin-left: 10px;margin-right: 5px;"
                >
                  <el-option
                    v-for="item in conditionList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input
                  v-model.number="item.number"
                  placeholder="设置次数"
                  style="width: 90px;margin-right: 8px;text-align: center;"
                ></el-input>
                <i
                  class="el-icon-delete"
                  style="color: #999;cursor: pointer;"
                  @click.stop="deleteBehavior(index)"
                ></i>
              </div>
              <div class="add" @click="addBehavior">+ 添加条件</div>
            </div>
          </div>
          <div class="box">
            <div class="box-title">
              <div class="left">
                获得该标签用户人数
                <div class="tip" style="color: #333;">{{userList.length || 0}}</div>
              </div>
              <!-- <div class="btn" @click="saveBehavior">保存条件</div> -->
            </div>
            <div class="table-box">
              <el-table
                :data="userList"
                class="order-table table no-border-table"
                style="width: 800px;"
                height="400"
                ref="orderTable"
                :header-cell-style="{
                  border: '1px solid #E8E8E8',
                  color: '#333',
                  background: '#f6f6f6',
                  height: '44px',
                }"
                :row-style="{
                  height: '44px',
                }"
              >
                <el-table-column
                  prop="uid"
                  align="center"
                  label="用户id"
                  width="280"
                ></el-table-column>
                <el-table-column
                  prop="nickname"
                  align="center"
                  label="用户名称"
                  width="280"
                ></el-table-column>
                <el-table-column label="操作" align="center" width="240">
                  <div
                    slot-scope="scope"
                    style="display: flex;justify-content: center;"
                  >
                    <div>
                      <button
                        size="mini"
                        class="table-btn"
                        style="color: #5283FF;cursor: pointer;"
                        @click="toUserDetail(scope.row.uid)"
                      >
                        查看用户详情
                      </button>
                    </div>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="addLabelVisible"
      class="dialog"
      width="400px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">
        添加标签组
      </div>
      <el-form ref="form" class="form" label-width="auto">
        <el-form-item label="标签名称:" prop="firstName" class="form-item">
          <el-input
            size="small"
            placeholder="请输入标签名称"
            class="add-renovation-input"
            style="width: 200px"
            v-model="firstLabelForm.firstName"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="标签描述:" prop="desc" class="form-item">
          <el-input
            size="small"
            placeholder="请输入标签描述"
            class="add-renovation-input"
            style="width: 200px"
            v-model="firstLabelForm.desc"
          ></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="addLabelVisible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="addLabel">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="addSecondLabelVisible"
      class="dialog"
      width="400px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">
        添加标签组
      </div>
      <el-form ref="form" class="form" label-width="auto">
        <el-form-item label="标签名称:" prop="secondName" class="form-item">
          <el-input
            size="small"
            placeholder="请输入标签名称"
            class="add-renovation-input"
            style="width: 200px"
            v-model="secondLabelForm.secondName"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="addSecondLabelVisible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="addSecondLabel"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import { staticImg, AREA_OSS } from '@/config'; // oss 图片地址
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '反馈详情'
      },
      portraitList: [],
      defaultProps: {
        children: 'second',
        label: 'name'
      },
      firstLabelForm: {},
      secLabelForm: {},
      addLabelVisible: false,
      addSecondLabelVisible: false,
      secondLabelForm: {},
      labelInfo: {},
      behavior: [],
      behaviorList: [],
      condition: [],
      conditionList: [],
      upgradeRulesData: [],
      userList: []
    };
  },
  mounted() {
    // 获取列表
    this.getPortraitList();
    this.getPortraitBehaviorList();
  },
  computed: {},
  methods: {
    // 获取轮播列表
    getPortraitList() {
      this.loading++;
      this.httpGet(this.$root.getPortraitList, {}).then(
        (res) => {
          this.loading--;
          this.portraitList = res.list.map(item => {
            return {
              ...item,
              name: item.firstName,
              second: item.second ? item.second.map(item2 => {
                return {
                  ...item2,
                  name: item2.secondName
                }
              }) : []
            }
          });
          console.log(this.portraitList);
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    addLabelModal(){
      this.firstLabelForm = {
        firstName: '',
        desc: ''
      }
      this.addLabelVisible = true;
    },
    addLabel(){
      this.httpPost(this.$root.addPortraitFirstLabel, this.firstLabelForm).then(
        (res) => {
          this.loading--;
          this.getPortraitList();
          this.addLabelVisible = false;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    addSecondLabelModal(data){
      // console.log(data);
      this.secondLabelForm = {
        fid: data.id,
        secondName: ''
      };
      this.addSecondLabelVisible = true;
    },
    addSecondLabel(){
      this.httpPost(this.$root.addPortraitSecondLabel, this.secondLabelForm).then(
        (res) => {
          this.loading--;
          this.getPortraitList();
          this.addSecondLabelVisible = false;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    deleteLabel(data){
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该标签吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        let url = this.$root.deletePortraitFirstLabel;
        if(data.fid) url = this.$root.deletePortraitSecondLabel;
        this.httpPost(url, {
          id: data.id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getPortraitList(null);
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    getPortraitBehaviorList(){
      this.loading++;
      this.httpGet(this.$root.getPortraitBehaviorList, {}).then(
        (res) => {
          this.loading--;
          this.behavior = res.behavior;
          let behaviorList = [];
          for(let key in res.behavior){
            behaviorList.push({
              label: res.behavior[key],
              value: +key
            })
          };
          this.behaviorList = behaviorList;
          this.condition = res.condition;
          let conditionList = [];
          for(let key in res.condition){
            conditionList.push({
              label: res.condition[key],
              value: +key
            })
          };
          this.conditionList = conditionList;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    addBehavior(){
      this.upgradeRulesData.push({
        sid: this.labelInfo.id,
        behavior: null,
        condition: null,
        number: null
      })
    },
    deleteBehavior(index){
      this.upgradeRulesData.splice(index, 1);
    },
    saveBehavior(){
      this.loading++;
      this.httpPost(this.$root.addPortraitBehavior, {
        upgradeRulesData: this.upgradeRulesData.map(item => {
          return {
            ...item,
            number: +item.number
          }
        })
      }).then(
        (res) => {
          this.loading--;
          this.$message.success('操作成功');
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    handleNodeClick(data){
      if(!data.fid) return;
      this.labelInfo = data;
      this.upgradeRulesData = [];
      this.userList = [];
      this.getPortraitSecondLabelInfo();
      this.getUserListByPortrait();
      console.log(data);
    },
    getPortraitSecondLabelInfo(){
      this.loading++;
      this.httpGet(this.$root.getPortraitSecondLabelInfo, {
        id: this.labelInfo.id
      }).then(
        (res) => {
          this.loading--;
          console.log(res);
          this.upgradeRulesData = res.map(item => {
            return {
              sid: item.sid,
              behavior: item.behavior,
              condition: item.condition,
              number: item.number,
            }
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getUserListByPortrait(){
      this.loading++;
      this.httpGet(this.$root.getUserListByPortrait, {
        sid: this.labelInfo.id
      }).then(
        (res) => {
          this.loading--;
          this.userList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    toUserDetail(uid){
      this.$router.push({
        name: 'userDetail',
        query: {
          uid
        }
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;
  background: #F6F6F6;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    // padding: 0 20px 20px;
    background: #F6F6F6;


    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      // background: white;
      box-sizing: border-box;
      padding: 10px 12px;
      border-radius: 2px;
      flex-x(flex-start, flex-start);
      .label-list{
        width: 220px;
        min-width: 220px;
        height: 100%;
        border-radius: 5px;
        overflow: hidden;
        flex-y(flex-start, flex-start);
        .label-top{
          width: 100%;
          height: 80px;
          background: #fff;
          .title{
            word(16px, #333);
            padding-top: 14px;
            padding-left: 16px;
            font-weight: bold;
          }
          .info{
            flex-x();
            padding-left: 16px;
            margin-top: 18px;
            word(14px, #999);
            .btn{
              padding: 0 5px;
              height: 24px;
              border-radius: 5px;
              background: #618EFF;
              word(12px, #fff);
              flex-x(center);
              margin-right: 10px;
              cursor: pointer;
            }
          }
        }
        .label{
          width: 100%;
          flex: 1;
          background: #fff;
          margin-top: 1px;
          padding: 10px 10px 0;
          box-sizing: border-box;
          .custom-tree-node{
            width: 100%;
            flex-x();
            .name{
              flex: 1;
              i{
                color: #618EFF;
                font-size: 16px;
              }
            }
            .btn-box{
              i{
                margin: 0 3px;
                word(14px, #999);
              }
            }
          }
        }
      }
      .label-info{
        margin-left: 10px;
        flex: 1;
        .name{
          height: 64px;
          width: 100%;
          background: #fff;
          flex-x(flex-start, center);
          padding-left: 24px;
          word(20px, #404157);
          box-sizing: border-box;
          border-radius: 5px;
        }
        .box{
          margin-top: 8px;
          border-radius: 5px;
          overflow: hidden;
          .box-title{
            width: 100%;
            background: #fff;
            height: 56px;
            flex-x();
            padding-left: 24px;
            padding-right: 24px;
            box-sizing: border-box;
            word(16px, #333);
            .left{
              flex-x(flex-start);
            }
            .tip{
              word(14px, #FF5733);
              margin-left: 12px;
            }
            .btn{
              width: 85px;
              height: 32px;
              border-radius: 5px;
              background: #618EFF;
              flex-x(center, center);
              word(14px, #fff);
              cursor: pointer;
            }
          }
          .behavior-list{
            flex-x();
            flex-wrap: wrap;
            background: #fff;
            margin-top: 1px;
            padding: 0 32px 50px;
            .item{
              width: 49%;
              min-width: 600px;
              height: 64px;
              flex-x(flex-start);
              white-space: nowrap;
              background: #F2F2F2;
              border-radius: 5px;
              padding: 0 24px;
              box-sizing: border-box;
              margin-top: 18px;
            }
            .add{
              width: 49%;
              min-width: 600px;
              height: 64px;
              background: #E8EFFF;
              border-radius: 5px;
              flex-x(center);
              word(14px, #4278FF);
              cursor: pointer;
              margin-top: 18px;
            }
          }
          .table-box{
            width: 100%;
            background: #fff;
            padding: 18px 36px;
            margin-top: 1px;
          }
        }
      }
    }
  }
  .form {
    margin-top: 30px;
    margin-bottom: 30px;
    padding-left: 40px;
  }
}
</style>
